import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

export type FilterLayoutStyleProps = {
	topOffset: number;
	fileTreeMaxHeight: number;
};

export const useStyles = makeStyles(() => {
	return {
		showroomFilterTreeInnerWrapper: {
			paddingBottom: 20
		},
		treeDivider: {
			marginTop: 24,
			marginBottom: 24,
			backgroundColor: grey[200]
		}
	};
});
